import { Text } from '@clay-run/glaze/text';
import type { AccountRow } from '@shared/flow/account-view';
import { EMPTY_VALUE } from '../account/accountFieldFormat';
import { GsAccountAvatar } from './GsAccountAvatar';

/** "Enterprise · Software", whichever parts exist, or null when neither does (no dangling separator). */
function sublineOf(row: AccountRow): string | null {
  const parts = [row.company_segment, row.industry].filter((part): part is string => !!part);
  return parts.length > 0 ? parts.join(' · ') : null;
}

/**
 * The Growth Strategist ledger's Account cell, as the GS design (egs-view at e7603325b) draws it:
 * the `sm` square avatar beside the bold name, over a "Segment · Industry"
 * line from the row's `company_segment` and `industry`. A row with neither
 * part is the name alone.
 */
export function GsAccountCell({ row }: { row: AccountRow }) {
  const subline = sublineOf(row);
  return (
    <span data-testid="gs-account-cell" className="flex min-w-0 items-center gap-2.5">
      <GsAccountAvatar accountId={row.id} name={row.name} size="sm" />
      <span className="flex min-w-0 flex-col">
        <Text size="sm" weight="semibold" render={<span />} className="truncate">
          {row.name ?? EMPTY_VALUE}
        </Text>
        {subline && (
          <Text size="xs" variant="secondary" render={<span />} className="truncate">
            {subline}
          </Text>
        )}
      </span>
    </span>
  );
}
